import React from 'react';

import Skeleton from '@components/Skeleton';

const NotificationItemSkeleton = () => {
  return (
    <div
      data-testid="notification-item-skeleton"
      className="flex gap-x-1 px-5 py-2 border-b border-neutral-50 text-start w-full"
    >
      <div className="w-full">
        <Skeleton className="w-[200px] h-5 mb-2" />
        <Skeleton className="w-full h-4 mb-1" />
        <Skeleton className="w-40 h-4 mb-1" />
      </div>
    </div>
  );
};

export default NotificationItemSkeleton;
